module.exports = new __parcel__URL__("lightModeInlineComment.308e6718.gif").toString();